const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:3000'
const API_V1   = '/_services/us/v1/'
const PREFIX   = API_HOST + API_V1

export const endpoints  = {
  users_url:         PREFIX + 'users',
  members_count_url: PREFIX + 'statistics/members_count',
  resend_email_url:  PREFIX + 'users/resend_soi_email',
  unsubscribe_url:   PREFIX + 'users/unsubscribe',
  create_du_url:     PREFIX + 'users/create_bu',
  rate_newsletter:   PREFIX + 'ratings',
  newsletter_rating: PREFIX + 'ratings',
  page_ratings:      PREFIX + 'page_ratings',
  meta:              PREFIX + 'meta',
}
